module.exports = function () {
  // Regex101: https://regex101.com/r/Fixkdm/1
  return document.body.className.match(/theme-[a-zA-Z-]*/)[0].replace('theme-', '')
}
